import { Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { AuthService } from '@core/authentication/auth.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';

import { TermsAndPolicyService } from './terms-and-policy.service';

@Injectable()
export class TermsAndPolicyGuardService implements CanActivate {
    private window: Window;

    constructor(
        @Inject(Window) window: Window,
        private authenticationService: AuthService,
        private authTokenService: AuthTokenService,
        private termsAndPolicyService: TermsAndPolicyService,
    ) {
        this.window = window;
    }

    public canActivate(): Observable<boolean> {
        // tslint:disable-next-line:no-bitwise
        const isAdminMaster: boolean = !!(this.authTokenService.role & RoleTypes.AdministratorMaster);
        if (!isAdminMaster) {
            return observableOf(true);
        }

        return this.termsAndPolicyService.checkAgreement()
            .pipe(tap((response: boolean) => {
                if (!response) {
                    this.authenticationService.logout();
                    this.authenticationService.navigateToLogin();
                    this.window.location.reload();
                }
            }));
    }
}
